import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ArticleField } from "./ArticleField";
import moment from "moment";
import LoadHljsModule from "../../common/chunks/Hljs";

export const KbArticle = ({ kbArticle }) => {
  const lastModifiedDate = moment(kbArticle.lastModifiedDate);

  useEffect(() => {
    async function highlight() {
      const hljs = await LoadHljsModule();
      document.querySelectorAll(".ckeditor_codeblock").forEach((block) => {
        hljs.highlightBlock(block);
      });
    }
    highlight();
  }, [kbArticle]);

  return (
    <div className="kb-article">
      <h2>{kbArticle.title}</h2>
      {lastModifiedDate.isValid() && (
          <p>
            Last modified {lastModifiedDate.format("LLL")} ({lastModifiedDate.fromNow()})
          </p>
        )
      }
      <dl>
        <ArticleField field="Overview" html={kbArticle.overview} />
        <ArticleField field="Applies To" html={kbArticle.appliesTo} />
        <ArticleField field="Cause" html={kbArticle.cause} />
        <ArticleField field="Solution" html={kbArticle.solution} />
      </dl>
    </div>
  );
};

KbArticle.propTypes = {
  kbArticle: PropTypes.shape({
    lastModifiedDate: PropTypes.string,
    title: PropTypes.string.isRequired,
    overview: PropTypes.string,
    appliesTo: PropTypes.string,
    cause: PropTypes.string,
    solution: PropTypes.string
  }).isRequired
};
